<div class="page-container unified">
  <div class="login-content-container">
    <div class="login-container col-12 col-md-6 col-lg-5">
      <div class="logo-container mb-5">
        <img
          class="col-8 col-md-6 col-lg-4"
          src="{{ './assets/rb-blue-logo.png' }}"
          alt="RightBridge"
        />
      </div>

      <div class="login-component-container">
        <div class="text-container mb-5">
          <h2>Welcome back!</h2>
          <p>Log in to your account</p>
        </div>

        <div class="login-form-container">
          <form>
            <mat-form-field floatPlaceholder="auto" class="col-12">
              <mat-label>Username</mat-label>
              <input
                matInput
                [placeholder]="'Username'"
                [type]="'text'"
                name="'username'"
                [formControl]="username"
                required
              />
              <mat-error>A username is required</mat-error>
            </mat-form-field>
            <mat-form-field floatPlaceholder="auto" class="col-12">
              <mat-label>Password</mat-label>
              <input
                matInput
                [placeholder]="'Password'"
                [type]="'password'"
                name="'password'"
                [formControl]="password"
                required
              />
              <mat-error>A password is required</mat-error>
            </mat-form-field>
            <div class="login-button-container col-12 mb-2">
              <button
                class="col-12"
                matButton="elevated"
                [type]="'submit'"
                color="primary"
                (click)="login()"
                id="login-button"
              >
                Log In<mat-icon>input</mat-icon>
              </button>
            </div>
          </form>
        </div>
        @if (failed) {
          <div class="failed">
            @if (loginError === 'Invalid') {
              <p class="col-12 warning-text">
                Sorry, it looks like either your username or password are
                incorrect. Please double check them and try again.
              </p>
            } @else if (loginError === 'Locked') {
              <p class="col-12 warning-text">
                Your account is locked due to multiple failed log in attempts.
                Please contact your technical support for assistance.
              </p>
            } @else if (
              loginError === 'Bad request' ||
              loginError === 'Unavailable' ||
              loginError === 'Server error'
            ) {
              <p class="col-12 warning-text">
                The server appears to be having an issue. Our team is on top of
                it! Please try again later.
              </p>
            }
          </div>
        }
        <ngx-loading
          [show]="loading"
          [config]="{ fullScreenBackdrop: false }"
        ></ngx-loading>
      </div>
    </div>

    <div class="login-decoration-container col-12 col-md-6 col-lg-7">
      <div class="content">
        <img
          alt="RightBridge logo"
          id="Polygon-1"
          src="{{ './assets/rightbridge-logo.png' }}"
          class="unified-logo"
        />
        <mat-icon
          id="Polygon-2"
          class="app-button-icon"
          svgIcon="aw_icon"
        ></mat-icon>
        <mat-icon
          id="Polygon-3"
          class="app-button-icon"
          svgIcon="pp_icon"
        ></mat-icon>
        <mat-icon
          id="Polygon-4"
          class="app-button-icon"
          svgIcon="iw_icon"
        ></mat-icon>
        <mat-icon
          id="Polygon-5"
          class="app-button-icon"
          svgIcon="lw_icon"
        ></mat-icon>
        <mat-icon
          id="Polygon-6"
          class="app-button-icon"
          svgIcon="cm_icon"
        ></mat-icon>

        <app-background-decoration></app-background-decoration>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
